<template>
    <div class="h-100 d-flex align-items-center justify-content-center flex-column">
        <h2 class="alert alert-danger">{{ e404 }}</h2>
        <router-link to="/dashboard">GO TO HOME</router-link>
    </div>
</template>

<script>
export default {
    data() {
        return {
            e404: "Page Not Found",
        };
    },
};
</script>
